export const vitalSignsGroupNames = [
    'Temperature',
    'Blood Pressure',
    'Body Composition',
    'Oxygen and Pulse Rate',
    'Blood Glucose',
];